import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import SuperAdminHeader from './SuperAdminHeader'

export default function EditBranch() {

    const { id } = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [loading, setLoading] = useState(false)  
    const [existingAdmins, setExistingAdmins] = useState([])
    const [existingBranches, setExistingBranches] = useState([])
    const [existingStaffs, setExistingStaffs] = useState([])
    
    const [formData, setFormData] = useState({
        branch_name:'',
        address:'',
        email:'',
        phone:''
    })
    
    const [errors, setErrors] = useState({
        branch_name:'',
        address:'',
        email:'',
        phone:''
    })

    const fetchBranch = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_branches/`, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('All Branches:', res.data)

            if(res.status === 200){
                const selectedBranch = res.data.data.find(item => String(item.id) === String(id))

                if(selectedBranch){
                    setFormData({
                        branch_name:selectedBranch.branch_name || '',
                        address: selectedBranch.address || '',
                        email: selectedBranch.email || '',
                        phone: selectedBranch.phone || ''
                    })
                } else {
                    toast.error('Branch not found')
                    navigate('/super_admin/all_branches')
                }
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to create branch'

            toast.error(message)
        }
    }
    useEffect(() => {
        if(id){
            fetchBranch()
        }
    },[id, token, navigate])

    useEffect(() => {
        const fetchExistingData = async () => {
        try {
            const headers = {
            Authorization: `Token ${token}`
            }

            const [
            adminsResponse,
            branchesResponse,
            staffsResponse
            ] = await Promise.all([
            axios.get(
                `${config.baseurl}get_all_admins/`,
                { headers }
            ),

            axios.get(
                `${config.baseurl}get_all_branches/`,
                { headers }
            ),

            axios.get(
                `${config.baseurl}get_all_staffs/`,
                { headers }
            )
            ])

            const admins = Array.isArray(adminsResponse.data)
            ? adminsResponse.data
            : adminsResponse.data?.data || []

            const branches = Array.isArray(branchesResponse.data)
            ? branchesResponse.data
            : branchesResponse.data?.data || []

            const staffs = Array.isArray(staffsResponse.data)
            ? staffsResponse.data
            : staffsResponse.data?.data || []

            console.log('Existing Admins:', admins)
            console.log('Existing Branches:', branches)
            console.log('Existing Staffs:', staffs)

            setExistingAdmins(admins)
            setExistingBranches(branches)
            setExistingStaffs(staffs)

        } catch (error) {
            console.error(
            'Failed to fetch existing data:',
            error.response?.data || error
            )
        }
        }

        if (token) {
        fetchExistingData()
        }
    }, [token])

    const handleChange = (e) => {
        const { name, value } = e.target

        let newValue = value
        let error = ''

        // ============================================================
        // BRANCH NAME - LIVE VALIDATION
        // ============================================================
        if (name === 'branch_name') {
        newValue = value

        const enteredName = newValue.trim().toLowerCase()

        if (!enteredName) {
            error = 'Branch Name is required'
        } else if (enteredName.length < 2) {
            error = 'Branch Name must contain at least 2 characters'
        } else if (!/^[a-zA-Z0-9\s&().'-]+$/.test(enteredName)) {
            error =
            'Branch Name can contain only letters, numbers, spaces and basic special characters'
        } else {

            // Branch
            const branchExists = existingBranches.some(
            (branch) =>
                String(branch.branch_name || '')
                .trim()
                .toLowerCase() === enteredName
            )

            if (branchExists) {
            error = 'This name already exists as a Branch'
            }

            // Admin
            if (!error) {
            const adminExists = existingAdmins.some(
                (admin) =>
                String(admin.admin_name || '')
                    .trim()
                    .toLowerCase() === enteredName
            )

            if (adminExists) {
                error = 'This name already exists as an Admin'
            }
            }

            // Staff
            if (!error) {
            const staffExists = existingStaffs.some((staff) => {
                const firstName = String(
                staff.first_name || ''
                ).trim()

                const lastName = String(
                staff.last_name || ''
                ).trim()

                const staffName =
                `${firstName} ${lastName}`
                    .trim()
                    .toLowerCase()

                return staffName === enteredName
            })

            if (staffExists) {
                error = 'This name already exists as a Staff'
            }
            }
        }
        }

        // ============================================================
        // ADDRESS - LIVE VALIDATION
        // ============================================================
        else if (name === 'address') {
        newValue = value

        if (!newValue.trim()) {
            error = 'Address is required'
        }
        }

        // ============================================================
        // PHONE - LIVE VALIDATION
        // ============================================================
        else if (name === 'phone') {
        newValue = value
            .replace(/\D/g, '')
            .slice(0, 10)

        if (!newValue) {
            error = 'Phone Number is required'
        }

        // First digit
        else if (!/^[6-9]/.test(newValue)) {
            error =
            'Phone number must start with 6, 7, 8 or 9'
        }

        // Length
        else if (newValue.length < 10) {
            error =
            'Phone number must contain exactly 10 digits'
        }

        // Duplicate check only after 10 digits
        else {

            // Branch
            const branchPhoneExists =
            existingBranches.some(
                (branch) =>
                String(branch.phone || '').trim() ===
                newValue
            )

            if (branchPhoneExists) {
            error =
                'This phone number already exists in a Branch'
            }

            // Admin
            if (!error) {
            const adminPhoneExists =
                existingAdmins.some(
                (admin) =>
                    String(admin.phone || '').trim() ===
                    newValue
                )

            if (adminPhoneExists) {
                error =
                'This phone number already exists for an Admin'
            }
            }

            // Staff
            if (!error) {
            const staffPhoneExists =
                existingStaffs.some(
                (staff) =>
                    String(staff.phone || '').trim() ===
                    newValue
                )

            if (staffPhoneExists) {
                error =
                'This phone number already exists for a Staff'
            }
            }
        }
        }

        // ============================================================
        // EMAIL - LIVE VALIDATION
        // ============================================================
        else if (name === 'email') {
        newValue = value.replace(/\s/g, '')

        if (!newValue) {
            error = 'Email Address is required'
        }

        else if (!newValue.includes('@')) {
            error = 'Missing @ symbol'
        }

        else {
            const emailParts = newValue.split('@')

            if (emailParts.length > 2) {
            error =
                'Email address can contain only one @ symbol'
            }

            else {
            const username = emailParts[0]
            const domain = emailParts[1]

            if (!username) {
                error =
                'Username is missing before "@"'
            }

            else if (!domain) {
                error = 'Domain name is missing'
            }

            else if (!domain.includes('.')) {
                error =
                'Missing "dot(.)" after domain name'
            }

            else {
                const allowedDomains = [
                'gmail.com',
                'yahoo.com',
                'hotmail.com',
                'outlook.com'
                ]

                if (
                !allowedDomains.includes(
                    domain.toLowerCase()
                )
                ) {
                error =
                    'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
                }

                // Proper email format
                else if (
                !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                    newValue
                )
                ) {
                error =
                    'Please enter a valid email address'
                }

                else {
                const enteredEmail =
                    newValue.trim().toLowerCase()

                // Branch
                const branchEmailExists =
                    existingBranches.some(
                    (branch) =>
                        String(branch.email || '')
                        .trim()
                        .toLowerCase() ===
                        enteredEmail
                    )

                if (branchEmailExists) {
                    error =
                    'This email already exists in a Branch'
                }

                // Admin
                if (!error) {
                    const adminEmailExists =
                    existingAdmins.some(
                        (admin) =>
                        String(admin.email || '')
                            .trim()
                            .toLowerCase() ===
                        enteredEmail
                    )

                    if (adminEmailExists) {
                    error =
                        'This email already exists for an Admin'
                    }
                }

                // Staff
                if (!error) {
                    const staffEmailExists =
                    existingStaffs.some(
                        (staff) =>
                        String(staff.email || '')
                            .trim()
                            .toLowerCase() ===
                        enteredEmail
                    )

                    if (staffEmailExists) {
                    error =
                        'This email already exists for a Staff'
                    }
                }
                }
            }
            }
        }
        }

        // ============================================================
        // UPDATE FORM DATA
        // ============================================================
        setFormData((prev) => ({
        ...prev,
        [name]: newValue
        }))

        // ============================================================
        // UPDATE ERROR LIVE
        // ============================================================
        setErrors((prev) => ({
        ...prev,
        [name]: error
        }))
    }
    
    // Validation
    const validateForm = (data) => {
        const newErrors = {}

        // ============================================================
        // BRANCH NAME
        // ============================================================

        const branchName = String(data.branch_name || '').trim()

        if (!branchName) {
        newErrors.branch_name = 'Branch Name is required'
        } else if (branchName.length < 2) {
        newErrors.branch_name = 'Branch Name must contain at least 2 characters'
        } else if (!/^[a-zA-Z0-9\s&().'-]+$/.test(branchName)) {
        newErrors.branch_name =
            'Branch Name can contain only letters, numbers, spaces and basic special characters'
        }


        // ============================================================
        // ADDRESS
        // ============================================================

        const address = String(data.address || '').trim()

        if (!address) {
        newErrors.address = 'Address is required'
        }


        // ============================================================
        // EMAIL
        // ============================================================

        const email = String(data.email || '')
        .trim()
        .toLowerCase()

        if (!email) {
        newErrors.email = 'Email Address is required'
        } else if (!email.includes('@')) {
        newErrors.email = 'Missing @ symbol'
        } else {
        const emailParts = email.split('@')

        if (emailParts.length > 2) {
            newErrors.email =
            'Email address can contain only one @ symbol'
        } else {
            const username = emailParts[0]
            const domain = emailParts[1]

            if (!username) {
            newErrors.email =
                'Username is missing before "@"'
            } else if (!domain) {
            newErrors.email =
                'Domain name is missing'
            } else if (!domain.includes('.')) {
            newErrors.email =
                'Missing "dot(.)" after domain name'
            } else {
            const allowedDomains = [
                'gmail.com',
                'yahoo.com',
                'hotmail.com',
                'outlook.com'
            ]

            if (!allowedDomains.includes(domain)) {
                newErrors.email =
                'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
            } else if (
                !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
            ) {
                newErrors.email =
                'Please enter a valid email address'
            }
            }
        }
        }


        // ============================================================
        // PHONE
        // ============================================================

        const phone = String(data.phone || '').trim()

        if (!phone) {
        newErrors.phone = 'Phone Number is required'
        } else if (!/^\d+$/.test(phone)) {
        newErrors.phone =
            'Phone number must contain only digits'
        } else if (!/^[6-9]\d{9}$/.test(phone)) {
        newErrors.phone =
            'Phone number must start with 6, 7, 8 or 9 and contain exactly 10 digits'
        }


        return newErrors
    }

    const handleUpdate = async (e) => {
        e.preventDefault()

        const validateErrors = validateForm(formData)

        setErrors(validateErrors)

        if (Object.keys(validateErrors).length > 0) {
            return
        }

        setLoading(true)

        try {
            const payload = {
                branch_name: formData.branch_name.trim(),
                address: formData.address.trim(),
                email: formData.email.trim(),
                phone: formData.phone.trim(),
            }

            console.log('Updating Branch Id:', id)
            console.log('Payload:', payload)

            const res = await axios.put(
                `${config.baseurl}update_branch/${id}/`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }
            )

            console.log('Sending Data:', formData)

            if (res.status === 200) {
                toast.success('Branch Updated Successfully')
                navigate('/super_admin/all_branches')
            } else {
                toast.error('Error occurred while updating branch')
            }

        } catch (error) {
            console.error(
                'Update Branch Error:',
                error.response?.data
            )

            const message =
                error.response?.data?.error?.[0] ||
                error.response?.data?.message ||
                'Error occurred'

            toast.error(message)

        } finally {
            setLoading(false)
        }
    }
    
    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
        <SuperAdminHeader/>

        <div className='max-w-7xl mx-auto px-6 pt-16 pb-6'>
            <div className='items-center justify-between text-center'>
                <h2 className='text-3xl font-bold mb-1'>Edit Branch</h2>
                <p className='mt-2 text-sm text-slate-500'>
                    Update the branch details below
                </p>
            </div>
        </div>

        <div className='max-w-7xl mx-auto px-6 pb-12 justify-between items-center'>
            <div className='mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg'>
                <div className='border-b border-slate-200 bg-slate-50 px-6 py-5 text-center text-lg'>
                    <h2 className='text-lg font-bold'>Branch Registration Form</h2>
                </div>

                {/* Form */}
                <form onSubmit={handleUpdate} className="p-6 md:p-8">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                        {/* Branch Name */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="branch_name"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Branch Name
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="branch_name"
                                type="text"
                                name="branch_name"
                                placeholder="Enter branch name"
                                value={formData.branch_name}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.branch_name
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.branch_name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.branch_name}</p>
                            )}
                        </div>

                        {/* Address */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="address"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Address
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <textarea
                                id="address"
                                name="address"
                                rows={4}
                                placeholder="Enter complete branch address"
                                value={formData.address}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.address
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.address && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.address}</p>
                            )}
                        </div>

                        {/* Phone */}
                        <div>
                            <label
                                htmlFor="phone"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Phone Number
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="phone"
                                type="text"
                                name="phone"
                                placeholder="Enter 10-digit phone number"
                                value={formData.phone}
                                onChange={handleChange}
                                maxLength={10}
                                inputMode="numeric"
                                className={`${inputClass} ${errors.phone
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.phone && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.phone}</p>
                            )}
                        </div>

                        {/* Email */}
                        <div>
                            <label
                                htmlFor="email"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Email Address
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="email"
                                type="email"
                                name="email"
                                placeholder="Enter email address"
                                value={formData.email}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.email
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.email && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.email}</p>
                            )}
                        </div>
                    </div>

                    {/* Form Actions */}
                    <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end">
                        <button
                            type="button"
                            disabled={loading}
                            onClick={() => navigate('/super_admin/all_branches')}
                            className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading}
                            className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {loading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}
